<template>
    <div v-if="item.is_clearance && item.saving_percentage > 0" class="text-xs">
        <span class="text-red-600">Save {{ item.saving_percentage }}%</span>
        <span v-if="showPipe" class="text-gray-500"> | </span>
        <span class="line-through text-gray-500">Was {{ currency(item.original_list_price) }}</span>
    </div>
</template>

<script type="text/javascript">

import currencyMixin from '@mixins/currency.js'

export default {
    name: 'ProductSaving',
    mixins: [ currencyMixin ],
    props: {
        item: {
            required: true,
        },
        showPipe: {
            required: false,
            default: true,
        }
    },
}

</script>
